<div class="container-fluid">
  <div class="row">
    <div class="col d-flex justify-content-end py-2">
      <button mat-stroked-button (click)="firstAccordion.closeAll(); secondAccordion.closeAll(); thirdAccordion.closeAll(); fourthAccordion.closeAll(); fifthAccordion.closeAll(); sixthAccordion.closeAll(); seventhAccordion.closeAll(); eighthAccordion.closeAll(); ninthAccordion.closeAll(); tenthAccordion.closeAll(); eleventhAccordion.closeAll()">Collapse All</button>
      <button mat-stroked-button (click)="firstAccordion.openAll(); secondAccordion.openAll(); thirdAccordion.openAll(); fourthAccordion.openAll(); fifthAccordion.openAll(); sixthAccordion.openAll(); seventhAccordion.openAll(); eighthAccordion.openAll(); ninthAccordion.openAll(); tenthAccordion.openAll(); eleventhAccordion.openAll()">Expand All</button>
    </div>
  </div>
  <div class="row">
    <div class="col">
        <!--  Question 1  -->
          <mat-accordion #firstAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why don’t I see all my contracts containing refunds present in the portal?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Your contract could be expired. Check the termination date on your executed agreement copy.
                If its expired and you would like to renew, please contact your Marketing representative to
                negotiate an amendment to extend.</p>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/agriculture-forest" target="_blank">Agriculture & Forest Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/coal" target="_blank">Coal Marketing</a></div>
              </div>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/automotive" target="_blank">Automotive Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/intermodal" target="_blank">Intermodal Marketing</a></div>
              </div>
              <div class="row">
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/chemicals" target="_blank">Chemicals Marketing</a></div>
                <div class="col-6"><a href="https://www.norfolksouthern.com/en/ship-by-rail/industry/metals-construction" target="_blank">Metals & Construction Marketing</a></div>
              </div>
              <p class="pt-3">If your agreement is not expired, it may not be ready to be loaded into the new system.
                Our new contract refund system is still in its infancy. We are constantly working to enhance the system
                to accommodate every contract so that all contracts can be present.
                Contact Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>) for more
                details on why a specific contract may not be represented in the refund portal.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 2  -->
          <mat-accordion #secondAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why can’t I see all previously paid refund periods?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>The refund portal in AccessNS only captures paid refund periods that are processed via the new system. Each paid period will stay visible in the refund portal for 60 days beyond the contract expiration date. </p>
              <p>Historical refunds paid through our legacy system will not be visible. If you have questions about historical payment data, please contact Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>). </p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 3  -->
          <mat-accordion #thirdAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What happens when one of my contacts leaves my company?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>If one of your refund portal contacts separates from your company, it’s important to let us know so we
                can protect your confidential refund information. Please contact Contract Compliance
                (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>)
                as soon as possible to have their access removed. Be sure to include their name, email address,
                and AccessNS User ID in your request. Please follow the ‘Gaining Access’ steps in the User Guide to
                setup a new contact for the refund portal.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 4  -->
          <mat-accordion #fourthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why does my refund in progress show a Potential Refund of $0.00 when I’ve shipped qualifying cars?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Your contract likely contains a carload/tonnage threshold provision.
                The system will populate all the qualifying shipments but the refund amount for each load will display
                $0.00 per car/ton until the threshold is met. Once the threshold is met, the refund amount per load
                will update for all qualifying carloads.</p>
              <p>Please keep in mind, some shipments may not yet appear due to the typical lag time between shipment
                and billing. Consequently, your company records may reflect you’ve met the threshold earlier than
                NS records. All qualifying shipments will be taken into account during refund reconciliation
                throughout the life cycle of the contract.</p>
              <p>Please review the specific terms of your executed agreement. If there is not a threshold provision
                and/or no carloads are present, but you believe you’ve shipped qualifying loads, please click
                “Contact Us” on the refund case.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 5  -->
          <mat-accordion #fifthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Why does my refund case show ‘No Refund Due’ at the end of the refund period?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Your contract could contain a carload/tonnage threshold provision. If NS records indicate not enough
                qualifying loads moved during the period to meet or exceed the threshold, you may not qualify for a
                refund.</p>
              <p>It’s also possible NS records may indicate no qualifying shipments moved during the refund period.</p>
              <p>Please review the specific terms in your executed agreement. If the refund case indicates
                ‘No Refund Due’ but you believe that is incorrect, please click “Contact Us” on the refund case.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 6  -->
          <mat-accordion #sixthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  The refund period has ended but qualifying candidates appear to be missing from the refund case. What do I do?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Let’s talk about timing. At the end of the refund period, the new system keeps the refund case “open”
                for an additional 14 days. This 2-week window was designed to allow any qualifying candidates that ship
                at the end of the period to make their way through the billing process. This helps maximize your refund!
                If you are viewing your potential refund during this 2-week window, please keep in mind that candidates
                will continue to populate.</p>
              <p>After the 2-week window closes, the refund case moves to an NS Review Period. Any qualifying candidates
                still lingering in the billing process will automatically be captured and populated in the next available
                refund case.</p>
              <p>Once the NS Review Period is complete, you will receive an automatic email notification letting you
                know your refund is ready for review and acceptance. If you believe the refund case is still missing
                candidates and you do not want to wait for the next refund period, you can opt to file a Dispute.
                During the dispute process, please provide a list of shipments – including car initial, car number,
                and ship date. Contract Compliance will work to incorporate any missing cars into the current refund period.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 7  -->
          <mat-accordion #seventhAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  My refund has been in ‘Under NS Review’ status a really long time. What’s going on?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>Our new contract refund system is still in its infancy. As with any new system, bugs can present
                unforeseen delays. We are constantly working to enhance the system to provide the best experience
                for our customers.</p>
              <p>We value your feedback! If you notice anything that seems out of place or incorrect, please don’t
                hesitate to click the “Contact US” button or email Contract Compliance
                (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>).</p>
              <p>If you have any questions on what is causing the delay, please contact Contract Compliance.</p>
            </mat-expansion-panel>
          </mat-accordion>
        <!--  Question 8  -->
          <mat-accordion #eighthAccordion="matAccordion" multi>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  What do I do if I believe the Potential Refund Amount or the Refund Offered is incorrect?
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p>If your refund period is still in progress and the Potential Refund amount appears incorrect, please
                click “Contact Us” and let us know why you believe the amount is incorrect.</p>
              <p>You can Dispute the Refund Offered at the end of the refund period by clicking the Dispute button on
                the refund case. Be sure to provide comments as to the reason(s) for your dispute and upload any
                pertinent documentation to help support your claim so we can expedite a resolution.</p>
            </mat-expansion-panel>
          </mat-accordion>
      <!--  Question 9  -->
      <mat-accordion #ninthAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Why does my refund case show an ‘Agreement Not Signed‘ status?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>NS controls require that all contract refund agreements be fully executed by both the customer and
            NS before payment can be issued. If your refund case status reflects ‘Agreement Not Signed’
            it means that the agreement covering the refund period is not yet executed by both parties. Please contact
            your Marketing representative to get an update on the status of your agreement.</p>
        </mat-expansion-panel>
      </mat-accordion>
      <!--  Question 10  -->
      <mat-accordion #tenthAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              When can I expect payment?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Once you accept your refund, you can expect payment quickly! There are a few internal audit control steps
            that follow your acceptance; therefore, an exact ETA is difficult to provide. Our goal is to complete
            those steps within 1-3 days after customer acceptance.</p>
        </mat-expansion-panel>
      </mat-accordion>
      <!--  Question 11  -->
      <mat-accordion #eleventhAccordion="matAccordion" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              My refund period is ending soon but my company has changed its bank account? What do I do to ensure we receive payment?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>If your entity has recently experienced a major change that would affect payment remittance
            (e.g. mergers, re-branding, relocation, bank account change, etc.),
            please contact Contract Compliance (<a href="mailto:contcomp@nscorp.com">contcomp@nscorp.com</a>).
            It’s important to let us know as early as possible, as vendor modifications require specific controls to
            be followed that can take time. You may be asked to provide documentation to support the changes such as
            a new W9, FATCA form (for foreign vendors), letter of assignment, ACH form, etc.</p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
